import { registerPrintRecord } from '@/api/modules/print'

export const PLATFORM_PRINT_FOOTER_TEXT = '此单据从智链商序平台打印'

const FOOTER_CLASS = 'platform-print-footer'
const META_CLASS = 'platform-print-meta'
const STYLE_ID = 'platform-print-footer-style'

function formatPrintTime(value) {
  if (!value) return '--'
  return String(value).replace('T', ' ').slice(0, 19)
}

export function buildPrintDocumentKey(...parts) {
  const source = parts.map(part => {
    if (part === null || part === undefined) return ''
    return typeof part === 'object' ? JSON.stringify(part) : String(part)
  }).join('|')

  let hash = 2166136261
  for (let index = 0; index < source.length; index += 1) {
    hash ^= source.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }
  return `${(hash >>> 0).toString(16)}:${source.slice(0, 150)}`
}

export async function installPlatformPrintFooter(targetWindow = window, container, identity) {
  const doc = targetWindow && targetWindow.document
  if (!doc) return

  let printRecord = null
  if (identity) {
    try {
      const response = await registerPrintRecord(identity.documentType, String(identity.documentKey))
      if (!response.data || !response.data.success || !response.data.data) {
        throw new Error(response.data?.message || '打印次数登记失败')
      }
      printRecord = response.data.data
    } catch (error) {
      if (targetWindow !== window && !targetWindow.closed) targetWindow.close()
      throw error
    }
  }

  if (!doc.getElementById(STYLE_ID)) {
    const style = doc.createElement('style')
    style.id = STYLE_ID
    style.textContent = `
      .${FOOTER_CLASS} {
        display: none;
      }

      .${META_CLASS} {
        display: none;
      }

      @media print {
        .${META_CLASS} {
          display: flex !important;
          align-items: center;
          gap: 24px;
          margin: 0 0 4mm;
          color: #333;
          font-family: "Microsoft YaHei", Arial, sans-serif;
          font-size: 11px;
          line-height: 1.4;
          break-inside: avoid;
          page-break-inside: avoid;
        }

        .${FOOTER_CLASS} {
          display: block !important;
          position: fixed !important;
          top: 50%;
          left: 50%;
          width: auto;
          margin: 0;
          padding: 0;
          transform: translate(-50%, -50%) rotate(-30deg);
          z-index: 2147483647;
          color: rgba(80, 80, 80, 0.08);
          font-family: "Microsoft YaHei", Arial, sans-serif;
          font-size: 34px;
          font-weight: 600;
          line-height: 1;
          text-align: center;
          white-space: nowrap;
          pointer-events: none;
          user-select: none;
        }
      }
    `
    ;(doc.head || doc.documentElement).appendChild(style)
  }

  const footerContainer = container || doc.body
  if (!footerContainer) return printRecord

  if (printRecord) {
    const existingMeta = footerContainer.querySelector(`.${META_CLASS}`)
    if (existingMeta) existingMeta.remove()

    const meta = doc.createElement('div')
    meta.className = META_CLASS
    const printTime = doc.createElement('span')
    printTime.textContent = `打印时间：${formatPrintTime(printRecord.printTime)}`
    const printCount = doc.createElement('span')
    printCount.textContent = `累计打印次数：第 ${printRecord.printCount} 次`
    meta.appendChild(printTime)
    meta.appendChild(printCount)
    footerContainer.insertBefore(meta, footerContainer.firstChild)
  }

  if (footerContainer.querySelector(`.${FOOTER_CLASS}`)) return printRecord

  const footer = doc.createElement('div')
  footer.className = FOOTER_CLASS
  footer.textContent = PLATFORM_PRINT_FOOTER_TEXT
  footerContainer.appendChild(footer)
  return printRecord
}
